import { Select, Stack, Switch } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { INFERENCE_INTERVAL_OPTIONS } from '../../LogicSelection/LogicHandler/constants'
import { FormValues } from '../DeploymentSettings'
import { SettingsCard } from '../SettingsCard'

type CameraGroupSettingsProps = {
  form: UseFormReturnType<FormValues>
  error?: ReactNode
}

export const CameraGroupSettings = ({
  form,
  error
}: CameraGroupSettingsProps) => {
  const intl = useIntl()
  const { runInGroups, inferenceInterval } = form.getValues()

  const offeredIntervals = INFERENCE_INTERVAL_OPTIONS.includes(
    inferenceInterval
  )
    ? INFERENCE_INTERVAL_OPTIONS
    : [...INFERENCE_INTERVAL_OPTIONS, inferenceInterval].sort((a, b) => a - b)

  const intervalOptions = offeredIntervals.map((interval) => ({
    value: String(interval),
    label: intl.formatMessage(
      { id: 'deployments.groupSettings.interval.option' },
      { n: interval + 1 }
    )
  }))

  return (
    <SettingsCard
      title={<FormattedMessage id="deployments.groupSettings.title" />}
      description={
        <FormattedMessage id="deployments.groupSettings.description" />
      }
    >
      <Stack gap="md">
        <Switch
          {...form.getInputProps('runInGroups', { type: 'checkbox' })}
          label={
            <FormattedMessage id="deployments.groupSettings.runInGroups.label" />
          }
          description={
            <FormattedMessage id="deployments.groupSettings.runInGroups.description" />
          }
          error={error}
          onChange={(event) => {
            form.setFieldValue('runInGroups', event.currentTarget.checked)

            if (!event.currentTarget.checked) {
              form.setFieldValue('gpuIndex', null)
            }
          }}
        />

        {runInGroups && (
          <Select
            data={intervalOptions}
            value={String(inferenceInterval)}
            allowDeselect={false}
            label={
              <FormattedMessage id="deployments.groupSettings.interval.label" />
            }
            description={
              <FormattedMessage id="deployments.groupSettings.interval.description" />
            }
            inputWrapperOrder={['label', 'input', 'description', 'error']}
            onChange={(value) => {
              if (value !== null) {
                form.setFieldValue('inferenceInterval', Number(value))
              }
            }}
          />
        )}
      </Stack>
    </SettingsCard>
  )
}
